<template>
  <div class="content no-flex active">
    <ed-section
      :title="getTitle"
      class="no-flex active"
      wide
    >
      <span slot="description">
        {{getDescription}}
      </span>
      <div class="col-md-8">
        <ed-form
          class="col-md-12"
          :submit-visible='false'
        >
          <ed-select
            v-if='model.displayFundingCurrencies'
            field-label='Funding Currency' 
            placeholder='Select a currency'
            :options='model.currencies'
            v-model='currency'
            label='Value'
            track-by='Value'
            required
            @select='selectFundingCurrency($event)'
            :openEndpoint='api.$.invoice.i2p.currencies'
            helptipHeader=''
            :error='errors.FundingCurrency'
            :helptip-body='errors.FundingCurrency && "Please select a Funding Currency" || ""'
            name='funding_currency'
          ></ed-select>

          <p
            v-if="
              !model.hideFundingEquivalentMessage &&
              (( model.displayFundingCurrencies &&
                currency &&
                currency.Key &&
                !isFundingCurrencySameOnPaymentRun
              ) || isFundingCurrencyDifferent)"
            class="funding-equivalent">
            {{paymentNonUSDMessage}}
          </p>

          <ed-input
            v-if="model.displayUSDEquivalent"
            field-label='USD Equivalent'
            @change="usdEquivalentChanged"
            v-model='model.usdEquivalent'
            :disabled='model.disableUSDEquivalent'
            type="money"
            amount
            autoselect
            helptipHeader=''
            :error='errors.USDEquivalentMissing'
            :helptip-body='errors.USDEquivalentMissing && "Please select USD Equivalent." || ""'
            name='usd_equivalent'
          />
          
          <ed-datepicker
            field-label='Scheduled Payment Date' placeholder='Select date'
            required
            :disabled="model.disablePaymentDate"
            v-model='paymentDate'
            @input="paymentDateChanged"
            :shortcuts="datepickerShortcuts"
            :notBefore='model.notBeforePaymentDate'
            :error='errors.PaymentDateMissing'
            :helptip-body='errors.PaymentDateMissing && "Please select a Payment Date." || ""'
            helptip-header=""
            name='scheduled_payment_date'
          ></ed-datepicker>

          <div class="col-md-12 no-pad">
            <ed-checkbox
              @click='checkApprovalCheckbox'
              :options='approvalCheckboxOptions'
              required
              :error='errors.ApprovalCheckboxError'
              :helptip-body='errors.ApprovalCheckboxError && "Please approve the submission of this payment" || ""'
              helptip-header=""
              name='approve_payment_checkbox'
            >
            </ed-checkbox>
          </div>
        </ed-form>
      </div>
      <div class="clear"></div>
    </ed-section>
  </div>
</template>


<script>

import { Eved } from '@/event-bus'

export default {
  props: {
    model: Object,
    errors: Object,
    invoiceModelCurrencies: Array,
    isFundingCurrencyDifferent: Boolean
  },

  activated() {
    this.$nextTick(() => {
      this.approvalCheckboxOptions[0].status = false
      this.paymentDate = new Date()
      this.emitChanges()
    })
  },

  deactivated() {
    this.$nextTick(() => {
      this.currency = {}
      this.model.usdEquivalent = 0
      this.paymentDate = new Date()
      this.approvalCheckboxOptions.status = false
    })
  },

  data () {
    return {
      currency: {},
      paymentDate: new Date(),
      approvalCheckboxOptions: [
        {
          label: 'I agree to the payment(s) specified below.',
          status: false
        }
      ],
      paymentNonUSDMessage: 'The Funding Equivalent listed below is based on the current indicative currency rate through Eved. ' +
        'A delay in submitting these payments through the site may cause the funding equivalent amount due to vary from what is currently displayed. ' +
        'The final funding equivalent and amount due for payment will show in your receipt and statement email.'
    }
  },

  computed: {
    isFundingCurrencySameOnPaymentRun() {
      if (this.invoiceModelCurrencies) {
        return this.invoiceModelCurrencies.length === 1 &&
          this.invoiceModelCurrencies[0] === this.currency.Key
      }
      return false
    },

    getTitle() {
      return this.model.displayUSDEquivalent
        ? 'Payment Information' // Post
        : 'Funding Information' // Make
    },

    getDescription() {
      return this.model.displayUSDEquivalent
        ? 'Enter the USD Equivalent and the schedule payment date for all the selected invoices.' // Post
        : (this.model.displayFundingCurrencies
          ? 'Enter the funding currency for all the selected invoices.'
          : '') // Make
    },

    datepickerShortcuts() {
      let today = { key: 'today', label: 'Today' }
      let yesterday = { key: 'yesterday', label: 'Yesterday' }

      if (this.model.disablePaymentDate) {
        return []
      } else if (this.model.hideDatePickerYesterdayLink) {
        return [today]
      } else {
        return [today, yesterday]
      }
    }
  },

  methods: {
    selectFundingCurrency(e) {
      this.currency = e
      this.errors.FundingCurrency = false
      this.emitChanges()
    },

    checkApprovalCheckbox(e) {
      this.errors.ApprovalCheckboxError = false
      this.emitChanges(utils.constants.invoice.ApprovalCheckbox)
    },

    usdEquivalentChanged(e) {
      this.emitChanges()
    },

    paymentDateChanged() {
      this.errors.PaymentDateMissing = false
      this.emitChanges()
    },

    emitChanges(from) {
      this.$emit(Eved.PAYMENT.FUNDING_INFO_CHANGED, {
        CurrencyCode: this.currency.Key,
        CurrencyName: this.currency.Value,
        Approval: this.approvalCheckboxOptions[0].status,
        USDEquivalent: parseFloat(this.model.usdEquivalent) || 0,
        PaymentDate: this.paymentDate,
        From: from
      })
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.details-text {
  font-size: 12px;
  color: #51226c;
}

.funding-equivalent {
    font-size: $font-size-base-sm;
    @include theme {
      color: v(ink);
    }
    margin-top: 1em;
    text-align: justify;
  }

</style>



// WEBPACK FOOTER //
// src/components/_modules/Payment/FundingInformation.vue